import moment from 'moment';

import { EVCharger, EVChargerCommunication, EVChargerStatus, EVChargerOutput, EVChargerType, EVChargerInstallationStatus } from "../../entity/station/evcharger";
import { EVChargerOutputTransformer } from "../transformers/evcharger-output";

export class EVChargerTransformer {
    transform(chargerInfo: any) : EVCharger {
        let charger = new EVCharger(
            chargerInfo.chargerId,
            chargerInfo.manufacturer,
            chargerInfo.serialNo,
            new EVChargerType(chargerInfo.chargerType),
            new EVChargerStatus(chargerInfo.status.code, chargerInfo.status.description, chargerInfo.status.remarks, chargerInfo.status.additionalinfo),
            chargerInfo.chargerModel
        )
        if(chargerInfo.installationStatus) {
            charger.installationStatus = new EVChargerInstallationStatus(chargerInfo.installationStatus.code, chargerInfo.installationStatus.description)
        }        
        if(chargerInfo.primaryCommunication) {
            charger.primaryCommunicaiton = new EVChargerCommunication(chargerInfo.primaryCommunication.code, chargerInfo.primaryCommunication.description)
        }
        if(chargerInfo.secondaryCommunication) {
            charger.secondaryCommunicaiton = new EVChargerCommunication(chargerInfo.secondaryCommunication.code, chargerInfo.secondaryCommunication.description)
        }
        if(chargerInfo.PNDEffectiveDate) {
            charger.pndEffectiveOn = moment(chargerInfo.PNDEffectiveDate, moment.ISO_8601).toDate()
        }
        if(chargerInfo.RETEffectiveDate) {
            charger.retEffectiveOn = moment(chargerInfo.RETEffectiveDate, moment.ISO_8601).toDate()
        } 
        if(chargerInfo.sendDataTransfer) {
            charger.sendDataTransfer = chargerInfo.sendDataTransfer
        }      
        let outputsInfos: any[] = chargerInfo.outputs
        if(outputsInfos) {
            let outputs: EVChargerOutput[] = []
            outputsInfos.forEach(outputInfo => {
                outputs.push(new EVChargerOutputTransformer().transform(outputInfo))
            });
            charger.outputs = outputs
        }
        return charger
    }

    deTransform(charger: EVCharger) : any {        
        let outputsInfos: any[] = []
        if(charger.outputs) {
            let outputs: EVChargerOutput[] = charger.outputs
            outputs.forEach(output => {
                outputsInfos.push(new EVChargerOutputTransformer().deTransform(output))
            });
        }
        let chargerInfo: any = {
            chargerId: charger.id,
            serialNo: charger.serialNumber,
            manufacturer: charger.manufacturer,
            chargerType: charger.type.id,   
            outputType: charger.type.chargerOutputType,
            inputVoltage: charger.type.inputVoltage,
            inputPhase: charger.type.inputPhase,            
            status: {
                code: charger.status.id
            },
            outputs: outputsInfos,
            noOfOutputs: outputsInfos.length
        }
        if(charger.primaryCommunicaiton) {
            chargerInfo = {
                ...chargerInfo,
                primaryCommunication: {
                    code: charger.primaryCommunicaiton.id
                }
            }
        }
        if(charger.secondaryCommunicaiton) {
            chargerInfo = {
                ...chargerInfo,
                secondaryCommunication: {
                    code: charger.secondaryCommunicaiton.id
                }
            }
        }
        if(charger.pndEffectiveOn) {
            chargerInfo = {
                ...chargerInfo,
                PNDEffectiveDate: charger.pndEffectiveOn.toISOString()
            }
        }
        if(charger.retEffectiveOn) {
            chargerInfo = {
                ...chargerInfo,
                RETEffectiveDate: charger.retEffectiveOn.toISOString(),
            }
        }
        return chargerInfo
    }
}